module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-timber-hamilton-0.e1c57321.jpg";